import { render } from "./Button.component.vue?vue&type=template&id=61bfea49&ts=true"
import script from "./Button.component.vue?vue&type=script&lang=ts"
export * from "./Button.component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__